<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import Vue from 'vue'

export default {
  name: 'app',
  created () {
    // 系统错误捕获
    Vue.config.errorHandler = (error, vm)=>{
      console.log(error);
    }
  }
}
</script>

<style lang="less">
@import '~style/common.less';
@import '~style/index.less';
</style>
